import React, { useEffect, useState } from "react";
import { aboutMeType } from "../../../../common/interfaces/myProfile/personalDetails/aboutMeType";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import { loanService } from "../../../../api/services/loanService";
import {
  setAllLoansHistory,
  setAllLoansHistoryLoader,
} from "../../../../infra/aggregates/myProfile/loansAggregates/loansHistorySlice";

interface PropsValues {
  setLoansFinishedData: (data: any) => void;
}

function DTOLoansFinished({ setLoansFinishedData }: PropsValues) {
  const dispatch = useAppDispatch();

  const selector = useAppSelector((state) => state.authSlice);

  const storeLoansHistory = useAppSelector(
    (state) => state.loansHistorySlice.loansHistory
  );
  async function getAllLoansFinished(empId: number) {
    dispatch(setAllLoansHistoryLoader(true));
    const response = await loanService.getLoansFinished(empId);
    if (response) {
      dispatch(setAllLoansHistory(response?.data));
      setLoansFinishedData(response?.data);
      dispatch(setAllLoansHistoryLoader(false));
    } else {
      dispatch(setAllLoansHistoryLoader(false));

      return;
    }
  }

  useEffect(() => {
    if (selector.emp_id) getAllLoansFinished(selector.emp_id);
  }, []);

  useEffect(() => {
    setLoansFinishedData(storeLoansHistory);
  }, [storeLoansHistory]);

  return <></>;
}
export default DTOLoansFinished;
